import React, { useState } from "react";
import axios from "../../axios/AxiosInstance";
import { message } from "antd";
import { apiErrorMessage } from "../../utils/apiError";

export default function PlacementInvoiceModal({ commande, candidate, client, onCreated, onClose }) {
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState(`Honoraires de recrutement — ${commande.qualification || ""}`);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const submit = async event => {
    event.preventDefault();
    const rate = Number(String(amount).replace(",", "."));
    if (saving || !Number.isFinite(rate) || rate <= 0 || !description.trim()) return;
    setSaving(true); setError("");
    try {
      const { data } = await axios.post("bill", {
        type: /cdd/i.test(commande.typeContrat || commande.contractType || "") ? "Placement CDD" : "Placement CDI",
        order: commande._id, candidate: candidate._id, client: client._id,
        qualification: commande.qualification, startDate: commande.startDate,
        endDate: commande.endDate, dates: [],
        facturation: [{ description: description.trim(), quantity: "1", rate: String(rate) }],
      });
      if (!data?._id) throw new Error("Réponse invalide");
      message.success("Facture de placement préparée."); onCreated?.(data); onClose();
    } catch (err) { setError(apiErrorMessage(err, "Impossible de préparer la facture.")); }
    finally { setSaving(false); }
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
    <form onSubmit={submit} role="dialog" aria-label="Facture de placement" className="w-full max-w-lg space-y-4 rounded-xl bg-white p-6">
      <h2 className="text-lg font-bold">Préparer la facture de placement</h2>
      <p>{client.companyName} · {candidate.firstname} {candidate.lastname}</p>
      <label className="block">Prestation<input required value={description} onChange={e => setDescription(e.target.value)} className="mt-1 w-full rounded-lg border bg-white p-2" /></label>
      <label className="block">Montant HT (€)<input required inputMode="decimal" value={amount} onChange={e => setAmount(e.target.value)} className="mt-1 w-full rounded-lg border bg-white p-2" /></label>
      {error && <p role="alert" className="text-rose-700">{error}</p>}
      <div className="flex justify-end gap-2"><button type="button" disabled={saving} onClick={onClose}>Fermer</button><button disabled={saving} className="rounded-lg bg-blue-700 px-4 py-2 text-white">{saving ? "Préparation…" : "Préparer la facture"}</button></div>
    </form>
  </div>;
}
